import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/violation-forum'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  listParams(uuid, params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}/${uuid}/school${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(violation, uuid) {
    return http.put(`${resource}/${uuid}`, violation)
  },
  add(violation) {
    return http.post(`${resource}`, violation)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
